import log from '../../utils/logger';

import { setDomainName } from '../../utils/utils';

const services = {
  getPageData: 'https://dev1.waters.com/bin/waters/content',

  getPageDataPath: 'nextgen/{localeCountry}/{localeLanguage}',

  getCountryStatus: 'https://dev1.waters.com/bin/waters/content',

  getCountryStatusPath: 'nextgen/{localeCountry}',

  shoppingCart:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}',

  orderSummaryData:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/coupons',

  addToCart:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/items',

  removeCart:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}',

  updateCart:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/items/{entry}',

  removeCartItem:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/items/{entry}',

  soldToDetails: 'https://dev1-services.waters.com/api/waters/user/v2/retrievesoldto',

  userDetails: 'https://dev1-services.waters.com/api/waters/user/v2/details',

  signOut: 'https://dev1-services.waters.com/api/waters/user/v2/logout',

  partnerInfo: 'https://api-sbox.waters.com/p2/ext-dev-waters-user-exp-api-v2/api/users/{userType}',

  country: 'https://dev1-services.waters.com/api/waters/country/v3/{code}',

  creditCards:
    'https://api-sbox.waters.com/p2/ext-dev-waters-user-exp-api-v2/api/users/{userType}/credit-cards',

  requestQuote:
    'https://api-sbox.waters.com/p2/ext-dev-waters-quote-exp-api-v2/api/{localeCountry}/{localeLanguage}/quote',

  addAddress: 'https://dev1-services.waters.com/api/waters/user/v1/{userType}/addresses',

  bulkUploadAddToCart:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}/entries',

  placeOrder:
    'https://api-sbox.waters.com/p2/ext-dev-waters-order-exp-api-v2/api/{localeCountry}/{localeLanguage}/orders',

  addCreditCard:
    'https://api-sbox.waters.com/p2/ext-dev-waters-user-exp-api-v2/api/users/{userType}/credit-cards',
  createSetupIntentId: 'https://dev1-services.waters.com/api/payment/v1/setup_intents',

  getPromoCodeDetails: 'https://dev1-services.waters.com/api/waters/coupon/v1/{promoCode}',

  setSwitchAccount: 'https://dev1-services.waters.com/api/waters/user/v2/switchaccount/{soldTo}',

  shoppingCartProxy:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/carts/{guid}',

  searchBar: 'https://dev1-services.waters.com/api/waters/search/v1/autocomplete',

  quoteDetails:
    'https://api-sbox.waters.com/p2/ext-dev-waters-quote-exp-api-v2/api/quote/{quoteId}',

  quoteToOrder:
    'https://api-sbox.waters.com/p2/ext-dev-waters-order-exp-api-v2/api/{localeCountry}/{localeLanguage}/quote/order',

  systemNotification:
    'https://dev1-services.waters.com/bin/waters/notifications.{localeLanguage}.json',

  shareCart:
    'https://api-sbox.waters.com/p2/ext-dev-waters-cart-exp-api-v1/api/{localeCountry}/{localeLanguage}/users/{userType}/cart/share',

  signIn: 'https://dev1-services.waters.com/api/waters/user/v2/login',

  userAuthentication: 'https://dev1-services.waters.com/api/waters/user/v2/isAuthenticated',
  retriveDPAToken: 'https://dev1-services.waters.com/api/payment/v1/retrieve_dpatoken',

  shareOrder:
    'https://api-sbox.waters.com/p2/ext-dev-waters-order-exp-api-v2/api/{localeCountry}/{localeLanguage}/order/share',

  pricingUrl:
    'https://api-sbox.waters.com/p2/ext-dev-waters-product-exp-api-v2/api/products/prices',

  announcementNotification:
    'https://dev1.waters.com/api/assets/waters/{localeLanguage}/content-fragments/notifications.json',
  createCustomerOnStripe: 'https://dev1-services.waters.com/api/payment/v1/customers',
};

try {
  if (window.apiEndpoints) {
    // if document referer exist

    // prepend in page data and country api

    const { getPageData, getCountryStatus } = window.apiEndpoints;

    window.apiEndpoints.getPageData = setDomainName(getPageData);

    window.apiEndpoints.getCountryStatus = setDomainName(getCountryStatus);

    Object.assign(services, window.apiEndpoints);
  }
} catch (error) {
  const obj = {
    message: 'API endpoints for the env are not available, using defaults',

    error,
  };

  log(obj);
}

export default services;
